import React from "react";
import { Formik, Form } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import MDBox from "../../../../../../components/MDBox";
import AddTimeToAllForm from "../../AddTimeForAllForm/AddTimeForAllForm";
import MDTypography from "../../../../../../components/MDTypography";

function AddTimeToAllDialog({
                                open, // Dialog state
                                onClose, // Function to close dialog
                                onSubmit, // Submit callback
                                formId, // Form identifier
                                initialValues, // Form initial values
                                validationSchema, // Yup validation schema
                                formField, // Form field structure
                                selectedTable, // Table details for cost calculation
                                players, // List of players for the form
                            }) {

    let extendedInitialValues = initialValues;
    extendedInitialValues.players = players.map(player => player.id);

    return (
        <Dialog open={open} onClose={onClose}>
            <Formik
                initialValues={extendedInitialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ values, errors, touched, setFieldValue }) => (
                    <Form id={formId} autoComplete="off">
                        <DialogTitle>Add Time to All Players</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Select players and configure the time options to proceed.
                            </DialogContentText>
                            <MDBox mt={2}>
                                {/* AddTimeToAllForm Component */}
                                <AddTimeToAllForm
                                    formData={{
                                        values,
                                        touched,
                                        formField,
                                        errors,
                                    }}
                                    setFieldValue={(field, value) => setFieldValue(field, value)}
                                    players={players}
                                />
                            </MDBox>
                            <MDBox mt={2}>
                                <MDTypography variant="h6" sx={{ marginBottom: 1 }}>
                                    Summary
                                </MDTypography>
                                <TableContainer component={Box}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Item</TableCell>
                                                <TableCell align="right">Cost</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {/* Summary for Hours */}
                                            <TableRow>
                                                <TableCell>Playing Hours By Player</TableCell>
                                                <TableCell align="right">
                                                    {values.is_free
                                                        ? "FREE"
                                                        : values.is_late_night
                                                            ? `$${values.hours * selectedTable?.late_seat_cost} USD`
                                                            : `$${values.hours * selectedTable?.seat_cost} USD`}
                                                </TableCell>
                                            </TableRow>
                                            {/* Total Cost */}
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: "bold" }}>
                                                    Total ({values.players.length} Player(s))
                                                </TableCell>
                                                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                    $
                                                    {values.is_free
                                                        ? '0 USD'
                                                        : (values.hours *
                                                        (values.is_late_night
                                                            ? selectedTable?.late_seat_cost
                                                            : selectedTable?.seat_cost) *
                                                        values.players.length) + ' USD' }
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </MDBox>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose}>Cancel</Button>
                            <Button type="submit">Add Time</Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

export default AddTimeToAllDialog;
